class GridViewToggle extends HTMLElement {
  constructor() {
    super();
    this.sectionId = this.dataset.sectionId;
    this.storageKey = `grid-view-${this.sectionId}`;
    this.init();
    this.setupGridObserver();
  }

  init() {
    this.productGrid = document.getElementById('product-grid');
    if (!this.productGrid) return;
    
    const buttons = this.querySelectorAll('.grid-view-toggle__button');
    if (buttons.length === 0) return;

    // Remove existing listeners to avoid duplicates
    buttons.forEach(button => {
      const newButton = button.cloneNode(true);
      button.parentNode.replaceChild(newButton, button);
    });

    // Detect current columns from class list
    let currentColumns = null;
    this.productGrid.classList.forEach(className => {
      const match = className.match(/grid--(\d+)-col-desktop/);
      if (match) {
        currentColumns = match[1];
      }
    });

    // Load saved preference or use current/default (default to 5 columns)
    const savedColumns = localStorage.getItem(this.storageKey);
    const defaultColumns = currentColumns || '5';
    const initialColumns = savedColumns || defaultColumns;
    
    // Ensure we only use 4 or 5 columns
    const validColumns = (initialColumns === '4') ? '4' : '5';

    // Set initial state
    this.setGridColumns(validColumns);
    this.updateButtonStates(validColumns);

    // Add click listeners
    this.querySelectorAll('.grid-view-toggle__button').forEach(button => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        const columns = button.dataset.columns;
        // Ensure only 4 or 5 columns
        if (columns === '4' || columns === '5') {
          this.setGridColumns(columns);
          this.updateButtonStates(columns);
          localStorage.setItem(this.storageKey, columns);
        }
      });
    });
  }

  setupGridObserver() {
    // Observe changes to ProductGridContainer to re-initialize when filters are applied
    const productGridContainer = document.getElementById('ProductGridContainer');
    if (!productGridContainer) return;

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
          // Check if product-grid was added/updated
          const hasProductGrid = Array.from(mutation.addedNodes).some(node => {
            if (node.nodeType === 1) { // Element node
              return node.id === 'product-grid' || node.querySelector('#product-grid');
            }
            return false;
          });
          
          if (hasProductGrid || document.getElementById('product-grid')) {
            // Re-initialize after a short delay to ensure DOM is ready
            setTimeout(() => {
              this.init();
            }, 100);
          }
        }
      });
    });

    observer.observe(productGridContainer, {
      childList: true,
      subtree: true
    });
  }

  setGridColumns(columns) {
    // Update productGrid reference in case it was replaced
    this.productGrid = document.getElementById('product-grid');
    if (!this.productGrid) return;

    // Remove all column classes
    const classesToRemove = [];
    this.productGrid.classList.forEach(className => {
      if (className.startsWith('grid--') && className.includes('-col-desktop')) {
        classesToRemove.push(className);
      }
    });
    classesToRemove.forEach(className => {
      this.productGrid.classList.remove(className);
    });

    // Add new column class
    this.productGrid.classList.add(`grid--${columns}-col-desktop`);
  }

  updateButtonStates(activeColumns) {
    const buttons = this.querySelectorAll('.grid-view-toggle__button');
    buttons.forEach(button => {
      if (button.dataset.columns === activeColumns) {
        button.classList.add('active');
      } else {
        button.classList.remove('active');
      }
    });
  }
}

customElements.define('grid-view-toggle', GridViewToggle);

